/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type GetDiscoveryProfilesQueryVariables = Types.Exact<{
  profileIds: Array<Types.Scalars["Int"]> | Types.Scalars["Int"];
  pipelineSlug: Types.Scalars["String"];
}>;

export type GetDiscoveryProfilesQuery = {
  profiles: Array<
    Pick<Types.Claim, "id"> & {
      fields: Array<
        Pick<Types.FieldWithAnswer, "slug" | "field_type" | "updated_at"> & {
          answer?: Types.Maybe<Pick<Types.FieldAnswer, "value" | "updated_at">>;
        }
      >;
    }
  >;
};

export const GetDiscoveryProfilesDocument = gql`
  query GetDiscoveryProfiles($profileIds: [Int!]!, $pipelineSlug: String!) {
    profiles: claims(
      where: {
        id: { in: $profileIds }
        pipeline: { is: { slug: { equals: $pipelineSlug } } }
      }
      take: 50
    ) {
      id
      fields {
        slug
        field_type
        updated_at
        answer {
          value
          updated_at
        }
      }
    }
  }
`;

/**
 * __useGetDiscoveryProfilesQuery__
 *
 * To run a query within a React component, call `useGetDiscoveryProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscoveryProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscoveryProfilesQuery({
 *   variables: {
 *      profileIds: // value for 'profileIds'
 *      pipelineSlug: // value for 'pipelineSlug'
 *   },
 * });
 */
export function useGetDiscoveryProfilesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetDiscoveryProfilesQuery,
    GetDiscoveryProfilesQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetDiscoveryProfilesQuery,
    GetDiscoveryProfilesQueryVariables
  >(GetDiscoveryProfilesDocument, baseOptions);
}
export function useGetDiscoveryProfilesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetDiscoveryProfilesQuery,
    GetDiscoveryProfilesQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetDiscoveryProfilesQuery,
    GetDiscoveryProfilesQueryVariables
  >(GetDiscoveryProfilesDocument, baseOptions);
}
export type GetDiscoveryProfilesQueryHookResult = ReturnType<
  typeof useGetDiscoveryProfilesQuery
>;
export type GetDiscoveryProfilesLazyQueryHookResult = ReturnType<
  typeof useGetDiscoveryProfilesLazyQuery
>;
export type GetDiscoveryProfilesQueryResult = ApolloReactCommon.QueryResult<
  GetDiscoveryProfilesQuery,
  GetDiscoveryProfilesQueryVariables
>;
